import React, { createContext, useContext, useState, useEffect } from 'react';

import { Plan } from 'api-bible-shared-lib/utils/types';
import { getPlans } from '../utils/api';

export interface PlansById {
  [id: string]: Plan;
}

interface PlansContextParams {
  plansById: PlansById;
  reloadPlansById: () => Promise<void>;
}

export const PlansContext = createContext<PlansContextParams>({
  plansById: {},
  reloadPlansById: () => {
    throw new Error('PlansContext not avaliable');
  },
});

export const usePlans = () => useContext(PlansContext);

export const PlansProvider = ({ children }: React.PropsWithChildren<{}>) => {
  const [plansById, setPlansById] = useState<PlansById>({});

  const reloadPlansById = async (): Promise<void> => {
    const sortedPlansById = (await getPlans())
      .sort((a, b) => a.sortOrder - b.sortOrder)
      .reduce((previous: PlansById, plan) => {
        const current = { ...previous };
        current[plan.id] = plan;
        return current;
      }, {});

    setPlansById(sortedPlansById);
  };

  // fetch plans from API

  useEffect(() => {
    reloadPlansById();
  }, []);

  return (
    <PlansContext.Provider value={{ plansById, reloadPlansById }}>{children}</PlansContext.Provider>
  );
};
